import React from 'react';
import { X, ZoomIn } from 'lucide-react';

const GalleryModal = ({ isOpen, images, onClose, onImageClick }) => {
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    } else {
      // Ensure overflow is reset when modal closes
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.92)' }}
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-7xl max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="fixed top-4 right-4 z-10 text-white hover:text-brand-gold transition-colors"
          aria-label="Close gallery"
        >
          <X size={32} />
        </button>

        {/* Masonry Grid */}
        <div 
          className="masonry-grid-container"
          style={{
            columnCount: 1,
            columnGap: '8px'
          }}
        >
          <style>{`
            @media (min-width: 640px) {
              .masonry-grid-container {
                column-count: 2;
              }
            }
            @media (min-width: 1024px) {
              .masonry-grid-container {
                column-count: 3;
              }
            }
          `}</style>
          
          {images.map((image, index) => (
            <div
              key={index}
              className="masonry-item group relative cursor-pointer mb-2"
              onClick={() => onImageClick(index)}
              style={{ breakInside: 'avoid' }}
            >
              <img
                src={image}
                alt={`Gallery image ${index + 1}`}
                className="w-full h-auto object-cover transition-transform duration-200"
                loading="lazy"
              />
              {/* Hover Overlay */}
              <div 
                className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
              >
                <ZoomIn size={32} className="text-white" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;
